export const WL_MINIMUM_CUSTOMER_AGE = 15;

export const WL_STARTER_LEGAL_AGE = 18;